
export function openGoogleMapViaLatLng(lat:string, lng:string) {
    const googleMapEmbededUrl = generateGoogleMapUrlWithLatLng(lat, lng);
    openInMobileBrowser(googleMapEmbededUrl);
}

export function generateGoogleMapUrlWithLatLng(lat, lng): string {
    return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
}

export function openInMobileBrowser(webUrl): void {
    const isIPhone = /iPhone|iPod|iPad|macintosh/i.test(navigator.userAgent);
    if(isIPhone){
        console.log('ios device');
    } else {
        console.log('android device');
    }
    const message = JSON.stringify({
        action: 'openBrowser',
        data: { url: webUrl }
    });

    if ((window as any).FlutterBridge) {
        console.log("[openBrowser] FlutterBridge detected.");
        (window as any).FlutterBridge.postMessage(message);
    }
}